(function (global) {
  'use strict';

  var ACTION_SELECTOR = '[data-bb-requires-ready-selection]';
  var ROOT_SELECTOR =
    '.bb-product, .bb-adh, .bb-simple-product, [data-bb-lp], [data-bb-bundle]';

  function text(value) {
    return value == null ? '' : String(value).trim();
  }

  function sortedProperties(properties) {
    return Object.keys(properties || {})
      .sort()
      .reduce(function (result, key) {
        result[key] = text(properties[key]);
        return result;
      }, {});
  }

  function failure(code, message, target) {
    return {
      ready: false,
      code: code,
      message: message,
      target: target || null,
    };
  }

  function evaluate(state) {
    state = state || {};
    if (!text(state.variantId)) {
      return failure(
        'variant',
        'Choose all product options before continuing.',
        state.variantTarget,
      );
    }
    if (!(Number(state.quantity) > 0)) {
      return failure(
        'quantity',
        'Enter a valid quantity before continuing.',
        state.quantityTarget,
      );
    }
    if (!state.authoritative) {
      return {ready: true, code: '', message: '', target: null};
    }
    if (state.pricingState === 'loading' || !state.pricingState) {
      return failure(
        'pricing',
        'Wait for current pricing to finish loading.',
        state.deliveryTarget,
      );
    }
    if (state.pricingState === 'unavailable') {
      return failure(
        'pricing',
        'Pricing is not available for this configuration.',
        state.deliveryTarget,
      );
    }
    if (!text(state.deliveryDate)) {
      return failure(
        'delivery_date',
        'Choose a ready-to-ship date before continuing.',
        state.deliveryTarget,
      );
    }
    if (state.pricingState !== 'selected') {
      return failure(
        'delivery_date',
        'Choose an available ready-to-ship date before continuing.',
        state.deliveryTarget,
      );
    }
    if (!text(state.configuration)) {
      return failure(
        'configuration',
        'Review the product options before continuing.',
        state.configurationTarget,
      );
    }
    return {ready: true, code: '', message: '', target: null};
  }

  function snapshot(state) {
    var properties = Object.freeze(sortedProperties(state.properties));
    var selection = {
      variantId: text(state.variantId),
      quantity: Number(state.quantity),
      deliveryDate: text(state.deliveryDate),
      offer: text(state.offer),
      configuration: text(state.configuration),
      printingMethod: text(state.printingMethod),
      properties: properties,
    };
    selection.fingerprint = JSON.stringify(selection);
    return Object.freeze(selection);
  }

  function matchesState(state, expected) {
    if (!expected) return false;
    return snapshot(state).fingerprint === expected.fingerprint;
  }

  function productRoot(action) {
    if (!global.document) return null;
    return (
      (action && action.closest && action.closest(ROOT_SELECTOR)) ||
      global.document.querySelector(
        '.bb-product, [data-bb-lp], [data-bb-bundle]',
      )
    );
  }

  function propertyName(field) {
    var name = field && field.getAttribute('name');
    var match = name && name.match(/^properties\[(.+)\]$/);
    return match ? match[1] : '';
  }

  function propertiesFor(root) {
    var properties = {};
    if (!root) return properties;
    root
      .querySelectorAll(
        'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]',
      )
      .forEach(function (field) {
        var name = propertyName(field);
        if (!name || field.disabled) return;
        if (
          (field.type === 'radio' || field.type === 'checkbox') &&
          !field.checked
        ) {
          return;
        }
        if (text(field.value)) properties[name] = field.value;
      });
    return properties;
  }

  function isBlankDesign(root) {
    var selected = root && root.querySelector(
      'input[name="properties[Design]"]:checked, select[name="properties[Design]"]',
    );
    return text(selected && selected.value).toLowerCase() === 'blank';
  }

  function setBlankDisabled(action, disabled) {
    if (!action) return;
    if (disabled) {
      action.disabled = true;
      action.dataset.bbDisabledForBlank = 'true';
      action.setAttribute('aria-disabled', 'true');
      action.setAttribute('title', 'Artwork is not needed for blank badges.');
      action.classList.remove('is-selection-locked');
      return;
    }
    if (action.dataset.bbDisabledForBlank === 'true') {
      action.disabled = false;
      action.removeAttribute('title');
      delete action.dataset.bbDisabledForBlank;
    }
  }

  function syncBlankDesignActions(root) {
    if (!root) return;
    if (!root.matches('.bb-product, .bb-adh, [data-bb-lp]')) return;
    var designControl = root.querySelector(
      'input[name="properties[Design]"], select[name="properties[Design]"]',
    );
    if (!designControl) {
      delete root.dataset.bbBlankDesign;
      return;
    }
    var blank = isBlankDesign(root);
    root.dataset.bbBlankDesign = String(blank);
    var primary = root.querySelector('[data-bb-open-zakeke]');
    var primaryText = primary && (
      primary.querySelector('[data-bb-design-primary-text]') ||
      primary.querySelector('.bb-summary__cta-text strong')
    );
    var primarySubtext = primary && (
      primary.querySelector('[data-bb-design-primary-subtext]') ||
      primary.querySelector('.bb-summary__cta-text span')
    );
    var primaryIcon = primary && primary.querySelector('.bb-summary__cta-icon');
    var upload = root.querySelector('[data-bb-upload-button], #bb-upload-btn');
    var sticky = global.document && global.document.querySelector('[data-bb-product-sticky]');
    var stickyPrimary = sticky && sticky.querySelector('[data-bb-sticky-btn]');
    var stickyUpload = sticky && sticky.querySelector('[data-bb-sticky-upload]');
    var stickyText = stickyPrimary && stickyPrimary.querySelector('span');
    var stickyIcon = stickyPrimary && stickyPrimary.querySelector('.bb-product-sticky__btn-icon');
    var savedDesign = Boolean(
      !blank && primary && primary.dataset.bbSavedDesign === 'true',
    );

    if (primary) primary.dataset.bbBlankAdd = String(blank);
    if (primaryText && !savedDesign) {
      primaryText.textContent = blank ? 'Add to Cart' : 'START DESIGNING';
    }
    if (primarySubtext && !savedDesign) {
      primarySubtext.textContent = blank
        ? 'Add these blank badges to your cart'
        : 'Choose one of our templates or start from scratch';
    }
    if (primaryIcon) primaryIcon.hidden = blank;
    setBlankDisabled(upload, blank);

    if (stickyPrimary) stickyPrimary.dataset.bbBlankAdd = String(blank);
    if (stickyText) stickyText.textContent = blank ? 'Add to Cart' : 'Start Designing';
    if (stickyIcon) stickyIcon.hidden = blank;
    setBlankDisabled(stickyUpload, blank);
  }

  function variantIdFor(root, deliveryRoot) {
    var selected = root && root.querySelector('[data-bb-selected-variant-id]');
    var idInput = root && root.querySelector('[name="id"]');
    var candidate =
      (selected && selected.value) ||
      (idInput && idInput.value) ||
      (root && root.getAttribute('data-variant-id')) ||
      (deliveryRoot && deliveryRoot.dataset.variantGid) ||
      '';
    var digits = text(candidate).replace(/\D/g, '');
    return digits;
  }

  function quantityField(root) {
    return (
      root &&
      (root.querySelector('[data-bb-active-quantity="true"]') ||
        root.querySelector(
          'input[name="quantity"], select[name="quantity"], .bb-qty-input, .bb-adh-qty__input, [data-bb-sp-qty], [data-bb-qty]',
        ))
    );
  }

  function stateFor(root) {
    var deliveryRoot =
      root && root.querySelector('[data-bb-delivery-date]');
    var deliveryInput =
      deliveryRoot &&
      deliveryRoot.querySelector('[data-bb-delivery-input]');
    var offerInput =
      deliveryRoot &&
      deliveryRoot.querySelector('[data-bb-delivery-offer]');
    var configurationInput =
      deliveryRoot &&
      deliveryRoot.querySelector('[data-bb-delivery-configuration]');
    var printingMethodInput =
      deliveryRoot &&
      deliveryRoot.querySelector('[data-bb-delivery-printing-method]');
    var quantityInput = quantityField(root);
    var authoritative = Boolean(
      deliveryRoot && deliveryRoot.dataset.deliveryRequired !== 'false',
    );
    return {
      variantId: variantIdFor(root, deliveryRoot),
      quantity: Number(quantityInput && quantityInput.value),
      authoritative: authoritative,
      pricingState:
        (root && root.dataset.bbAuthoritativePricingState) || '',
      deliveryDate: deliveryInput ? deliveryInput.value : '',
      offer: offerInput ? offerInput.value : '',
      configuration: configurationInput ? configurationInput.value : '',
      printingMethod: printingMethodInput ? printingMethodInput.value : '',
      properties: propertiesFor(root),
      variantTarget:
        root &&
        root.querySelector(
          '[data-bb-selected-variant-id], [data-bb-visual-radios], [data-bb-group]',
        ),
      quantityTarget: quantityInput,
      deliveryTarget: deliveryRoot,
      configurationTarget:
        root &&
        root.querySelector(
          '[data-bb-visual-radios], [data-bb-group], .bb-optcards',
        ),
    };
  }

  function capture(root) {
    return snapshot(stateFor(root));
  }

  function matches(root, expected) {
    return matchesState(stateFor(root), expected);
  }

  function guide(result) {
    var target = result.target;
    if (
      target &&
      target.matches &&
      target.matches('[data-bb-delivery-date]')
    ) {
      var status = target.querySelector('[data-bb-delivery-status]');
      if (status) {
        status.textContent = result.message;
        status.classList.add('is-error');
      }
    }
    if (global.BBToast && typeof global.BBToast.show === 'function') {
      global.BBToast.show({
        variant: 'warning',
        title: 'Complete your product setup',
        message: result.message,
        dedupeKey: 'product-action-readiness',
      });
    }
    if (target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
    var focusTarget =
      target &&
      (target.matches &&
      target.matches('button, input, select, textarea, [tabindex]')
        ? target
        : target.querySelector &&
          target.querySelector(
            'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
          ));
    if (focusTarget && typeof focusTarget.focus === 'function') {
      global.setTimeout(function () {
        focusTarget.focus({preventScroll: true});
      }, 250);
    }
  }

  function requireReady(root) {
    var state = stateFor(root);
    var result = evaluate(state);
    if (!result.ready) {
      guide(result);
      return null;
    }
    return snapshot(state);
  }

  function sync(root) {
    if (!root) return;
    syncBlankDesignActions(root);
    var ready = evaluate(stateFor(root)).ready;
    var actions = Array.from(root.querySelectorAll(ACTION_SELECTOR));
    if (global.document) {
      global.document
        .querySelectorAll(
          '[data-bb-product-sticky] ' + ACTION_SELECTOR,
        )
        .forEach(function (action) {
          if (actions.indexOf(action) === -1) actions.push(action);
        });
    }
    actions.forEach(function (action) {
      if (action.disabled) return;
      action.setAttribute('aria-disabled', String(!ready));
      action.classList.toggle('is-selection-locked', !ready);
    });
  }

  function initialize(scope) {
    if (!global.document) return;
    (scope || global.document)
      .querySelectorAll(
        '.bb-product, [data-bb-lp], [data-bb-bundle]',
      )
      .forEach(sync);
  }

  function rootFromEvent(event) {
    var action =
      event.target &&
      event.target.closest &&
      event.target.closest(ACTION_SELECTOR);
    return {action: action, root: productRoot(action)};
  }

  function interceptAction(event) {
    var resolved = rootFromEvent(event);
    if (!resolved.action || resolved.action.disabled || !resolved.root) return;
    var selected = requireReady(resolved.root);
    if (selected) {
      resolved.action.bbValidatedSelection = selected;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function syncFromEvent(event) {
    var root =
      productRoot(event && event.target) ||
      (global.document &&
        global.document.querySelector(
          '.bb-product, [data-bb-lp], [data-bb-bundle]',
        ));
    if (root) global.setTimeout(function () { sync(root); }, 0);
  }

  function bind() {
    if (!global.document || global.document.documentElement.dataset.bbReadinessBound === 'true') {
      return;
    }
    global.document.documentElement.dataset.bbReadinessBound = 'true';
    global.document.addEventListener('click', interceptAction, true);
    ['input', 'change', 'bb:price-update', 'bb:price-pending'].forEach(
      function (eventName) {
        global.document.addEventListener(eventName, syncFromEvent);
      },
    );
    global.addEventListener('bb:delivery-date-change', syncFromEvent);
    global.document.addEventListener('shopify:section:load', function (event) {
      initialize(event.target);
    });
    initialize(global.document);
  }

  global.BBProductActionReadiness = {
    ACTION_SELECTOR: ACTION_SELECTOR,
    evaluate: evaluate,
    snapshot: snapshot,
    matchesState: matchesState,
    productRoot: productRoot,
    stateFor: stateFor,
    capture: capture,
    matches: matches,
    requireReady: requireReady,
    sync: sync,
    syncBlankDesignActions: syncBlankDesignActions,
    initialize: initialize,
    bind: bind,
  };

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', bind, {once: true});
    } else {
      bind();
    }
  }
})(window);
